export const messages = {
  en: {
    printQuestionAnswerDetail: {
      table: {
        title: 'Title',
        type: 'Type',
        options: 'Options',
        choices: 'Choices'
      },
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      shortAnswer: 'Short Answer',
      total: 'Total',
      submitted: 'Submitted',
      people: 'people',
      print: 'Print',
      cancel: 'Cancel'
    }
  },
  zh: {
    printQuestionAnswerDetail: {
      table: {
        title: '名称',
        type: '类型',
        options: '选项',
        choices: '选择'
      },
      singleChoice: '单选',
      multipleChoice: '多选',
      shortAnswer: '简答',
      total: '总数',
      submitted: '已提交',
      people: '人',
      print: '打印',
      cancel: '取消'
    }
  }
}